import React, { useEffect, useRef } from 'react'
import './navigation.css'
import { Link, useNavigate } from 'react-router-dom'
import { Link as ScrollLink } from 'react-scroll'

// Data
import MenuData from '../../assets/MenuData.json'
import Button from '../button/Button'

const clickOutsideRef = (content_ref, toggle_ref) => {
    document.addEventListener('mousedown', (e) => {
        // user click toogle
        if (toggle_ref.current && toggle_ref.current.contains(e.target)){
            content_ref.current.classList.toggle('active')
        } else {
            // user click outside toggle and content
            if (content_ref.current && !content_ref.current.contains(e.target)){
                content_ref.current.classList.remove('active')
            }
        }
    })
}

function Navigation({ background, section }) {
    const navigate = useNavigate();

    const menu_ref = useRef(null);
    const menu_toggle_ref = useRef(null);

    clickOutsideRef(menu_ref, menu_toggle_ref);

    const setActiveMenu = () => menu_ref.current.classList.add('active');
    const closeMenu = () => menu_ref.current.classList.remove('active');

    const window_loction = window.location 

    useEffect(() => {
        const unlisten = () => {
            window.scrollTo(0,0);
        }

        unlisten();

    }, [window_loction]);

  return (
    <div className='nav_wrapper'>
        <div className={`nav ${background}`}>
            <div className='logo' onClick={() => navigate('/')}>
                <h2>W | A</h2>
                <p>29.07.2022</p>
            </div>

            <div className='menu'>
                {
                    MenuData &&
                    MenuData.map((menu, index) => (
                        <React.Fragment>
                            {
                                menu.target === "/" ? (
                                    <Link key={index} to='/' className='menu_link'>
                                        {menu.placeholder}
                                    </Link>
                                ) : (
                                    <ScrollLink key={index} to={menu.target} spy={true} smooth={true} className='menu_link' >
                                        {menu.placeholder}
                                    </ScrollLink>
                                )
                            }
                        </React.Fragment>
                    ))
                }

                {/* <ScrollLink className='scroll_btn' to="rsvp_section" spy={true} smooth={true}>

                    <Button 
                        content="RSVP"
                        background="transparent"
                        // routeAction="/rsvp"
                    />
                </ScrollLink> */}
            </div>

            <div className='mobile_menu' ref={menu_toggle_ref} onClick={() => setActiveMenu()}>
                <i class='bx bx-menu-alt-right'></i>
            </div>

            <div className='mobile_menu-content' ref={menu_ref}>
                <div 
                    className='mobile_menu-close'
                    onClick={() => closeMenu()}
                >
                    <i className="bx bx-x"></i>
                </div>

                <div className="mobile_menu-menu">
                    {
                        MenuData.map((menu, index) => (
                            <React.Fragment>
                                {
                                    window.location !== "/" || " " ? (
                                        <Link key={index} to={`/`} spy={true} smooth={true} className='mobile_menu-link' onClick={() => closeMenu()}>
                                            {menu.placeholder}
                                        </Link>
                                    ) : (
                                        <ScrollLink key={index} to={menu.target} spy={true} smooth={true} className='mobile_menu-link' onClick={() => closeMenu()}>
                                            {menu.placeholder}
                                        </ScrollLink>
                                    )
                                }
                                
                            </React.Fragment>
                        ))
                    }

                    <div className='mobile_menu-rsvpBtn'>
                        <ScrollLink className='scroll_btn' to="rsvp_section" spy={true} smooth={true} onClick={() => closeMenu()}>
                            <Button 
                                content="RSVP"
                                background="transparent"
                                // routeAction="/rsvp"
                            />
                        </ScrollLink>
                    </div>

                    

                </div>
            </div>
        </div>
    </div>
  )
}

export default Navigation